function showss(para) {
  $('#tabs'+para).slideToggle('1000');
  //$('#q'+para +' '+'i').toggleClass("ion-android-remove");

  if($('#qs'+para +' '+'img').attr('src') == 'https://cdn2.shopify.com/s/files/1/2264/4927/t/29/assets/arrow2.png?3544'){
    $('#qs'+para +' '+'img').attr('src', '//cdn2.shopify.com/s/files/1/2264/4927/t/29/assets/arrow1.png?3568');
  } else {
    $('#qs'+para +' '+'img').attr('src', 'https://cdn2.shopify.com/s/files/1/2264/4927/t/29/assets/arrow2.png?3544');
  }
}	

var max = -1;
$('.height_metch_me').each(function() {
  var h = $(this).height(); 
  max = h > max ? h : max;

  $(this).css({'min-height': max});
  	});
$(document).ready(function() {
  var maxHeight = 0;
      
  $('.price-tag__wrapper').each(function() {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  
  $('.price-tag__wrapper').height(maxHeight);
});